import {Component, Input} from '@angular/core';
import * as wjcGrid from '@mescius/wijmo.grid';

/**
 * 旧 kobe-ac.app の cb-grid-dynamic-columns (「設定」タブの列表示切替) 相当。
 * グリッドの列ごとに表示/非表示をチェックボックスで切り替える。
 */
@Component({
    standalone: false,
    selector: 'kobeac-column-settings',
    template: `
        <div class="row" *ngIf="grid">
            <div class="col-md-4" *ngFor="let col of grid.columns">
                <label class="mb-1">
                    <input type="checkbox" [checked]="col.visible" (change)="toggle(col)"/>
                    {{ col.header }}
                </label>
            </div>
        </div>
    `,
})
export class KobeacColumnSettingsComponent {
    @Input() grid: wjcGrid.FlexGrid;

    toggle(col: wjcGrid.Column): void {
        col.visible = !col.visible;
    }
}
